interface IAddressProps {
  title: string;
  dateTime: string;
}

const Address = ({title, dateTime}: IAddressProps) => {
  return (
    <div className="flex">
      <i className="icon-location pe-1 text-primary"></i>
      <small className="text-gray-6">{title}</small>
      <i className="icon-calendar pe-1 ps-2 text-primary"></i>
      <small className="text-gray-6">{dateTime}</small>
    </div>
  );
};

export default Address;
